import AbstractHardware from '@/lib/hardware/classes/AbstractHardware'
import inversBtSdk from '@/lib/inversBtSdk/inversBtSdk'

export interface InversConfig {
  pinRequester: () => Promise<string>
  device: string
  token: string
  session_key: string
}

export default class InversHardware extends AbstractHardware {
  constructor(conf: InversConfig) {
    super(conf)
  }

  public init() {
    const conf = this.config as InversConfig
    this.addAction('open', () => new Promise((resolve, reject) => {
      conf.pinRequester().then((pin) => {
        inversBtSdk.test(pin, 'start', conf.device, conf.token, conf.session_key, (r: string) => {
          this.statusLog(r)
        }, resolve, reject)
      }).catch(reject)
    }), 'ble')
    this.addAction('close', () => new Promise((resolve, reject) => {
      conf.pinRequester().then((pin) => {
        inversBtSdk.test(pin, 'end', conf.device, conf.token, conf.session_key, (r: string) => {
          this.statusLog(r)
        }, resolve, reject)
      }).catch(reject)
    }), 'ble')
    return Promise.resolve()
  }
}
